// Wave configurations for each region
export interface WaveConfig {
  region: number;
  wave: number;
  enemies: Array<{
    type: string;
    count: number;
    formation: string;
  }>;
  isBoss: boolean;
  isMiniBoss: boolean;
  bossType?: string;
}

// Formation patterns
export enum Formation {
  V_SHAPE = 'v_shape',
  LINE = 'line',
  SCATTERED = 'scattered',
  GRID = 'grid',
  CIRCLE = 'circle',
  WAVE = 'wave',
}

// Generate waves for all regions
export const WAVES: WaveConfig[] = [];

// Region 1 - East Coast
const region1Waves: WaveConfig[] = [
  {
    region: 1,
    wave: 1,
    enemies: [{ type: 'hunger_bug', count: 10, formation: Formation.V_SHAPE }],
    isBoss: false,
    isMiniBoss: false,
  },
  {
    region: 1,
    wave: 2,
    enemies: [{ type: 'shadow', count: 8, formation: Formation.SCATTERED }],
    isBoss: false,
    isMiniBoss: false,
  },
  {
    region: 1,
    wave: 3,
    enemies: [
      { type: 'hunger_bug', count: 6, formation: Formation.LINE },
      { type: 'shadow', count: 4, formation: Formation.SCATTERED },
    ],
    isBoss: false,
    isMiniBoss: false,
  },
  {
    region: 1,
    wave: 4,
    enemies: [
      { type: 'hunger_bug', count: 5, formation: Formation.LINE },
      { type: 'greed', count: 4, formation: Formation.SCATTERED }
    ],
    isBoss: false,
    isMiniBoss: false,
  },
  {
    region: 1,
    wave: 5,
    enemies: [{ type: 'greed', count: 8, formation: Formation.WAVE }],
    isBoss: false,
    isMiniBoss: false,
  },
  {
    region: 1,
    wave: 6,
    enemies: [
      { type: 'hunger_bug', count: 5, formation: Formation.V_SHAPE },
      { type: 'shadow', count: 3, formation: Formation.SCATTERED },
      { type: 'greed', count: 2, formation: Formation.LINE },
    ],
    isBoss: false,
    isMiniBoss: false,
  },
  {
    region: 1,
    wave: 7,
    enemies: [],
    isBoss: false,
    isMiniBoss: true,
    bossType: 'hunger_worm_jr',
  },
  {
    region: 1,
    wave: 8,
    enemies: [],
    isBoss: true,
    isMiniBoss: false,
    bossType: 'giant_hunger_worm',
  },
];

WAVES.push(...region1Waves);

// Generate similar patterns for other regions with increasing difficulty
for (let region = 2; region <= 5; region++) {
  const baseWaves = region1Waves.map((wave, index) => ({
    ...wave,
    region,
    wave: index + 1,
    enemies: wave.enemies.map(enemy => ({
      ...enemy,
      count: Math.floor(enemy.count * (1 + region * 0.15)),
    })),
  }));
  WAVES.push(...baseWaves);
}

export function getWaveConfig(region: number, wave: number): WaveConfig | undefined {
  return WAVES.find(w => w.region === region && w.wave === wave);
}

export function getTotalWavesForRegion(region: number): number {
  return WAVES.filter(w => w.region === region).length;
}
